import { ICreateSendContentsState } from '../../types/createSendContents';

/**
 * Repairs a rehydrated `contents` slice.
 *
 * `autoMergeLevel2` restores whatever is in storage verbatim, so `pygOptionOrder` has to be
 * proven an array here: a corrupt `persist:createSend` would otherwise reach `orderPygOptions`
 * during render and white-screen the Contents step.
 *
 * A transform only ever sees its own slice, so it cannot read `method`. Dropping marketplace
 * picks and the budget for a Location draft is the reducer's job instead — see the
 * `SET_CS_METHOD` case in `reducers/contents.ts`, which also covers an in-session switch.
 */
export const normalizePersistedContents = (
  outbound: Partial<ICreateSendContentsState> | undefined,
): ICreateSendContentsState =>
  ({
    ...outbound,
    items: Array.isArray(outbound?.items) ? outbound?.items : [],
    pygOptionOrder: Array.isArray(outbound?.pygOptionOrder) ? outbound?.pygOptionOrder : [],
  } as ICreateSendContentsState);
